import script from "./PublishedDocumentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishedDocumentsView.vue?vue&type=script&setup=true&lang=js"

import "./PublishedDocumentsView.vue?vue&type=style&index=0&id=644c0d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644c0d08"]])

export default __exports__